import React, { Component, PureComponent } from 'react';
import { Field, reduxForm, FieldArray } from 'redux-form'
import { Row, Form, Button, Icon, Input, Divider, Tooltip, Popconfirm } from 'antd';
import { RTLCol, RTLButton, RTLModal, RTLTable } from '../RTLKit';
import moment from 'jalali-moment'


/* ------ Field -------- */
import TextField from '../formFields/TextField';
import SelectField from '../formFields/SelectField';
import DescriptionList from '../formFields/DescriptionList';


/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import jwtDecode from "jwt-decode";
import Loading from "../loading/loading";

const columns = [
    {
        title: 'نوع درخواست',
        dataIndex: 'order_type',
    },
    {
        title: 'تاریخ',
        dataIndex: 'schedule_time',
    },
    {
        title: 'ساعت',
        dataIndex: 'schedule_hour',
    },
    {
        title: 'آدرس',
        dataIndex: 'address',
    },
];

class AssignChangeForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            orderId: this.props.match.params.orderId ? this.props.match.params.orderId : null,
            mode: this.props.match.params.id ? 'edit' : 'add',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            cities: [],
            formLayout: 'horizontal',
            role: this.props.userValue ? this.props.userValue.rl : null,
            showAssignTable: false,
        };
        this.props.setOrderId(this.state.orderId);

    }

    getDate() {
        const date = new Date();
        const formatter = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
        });
        const parts = formatter.formatToParts(date);
        function persianNumberToEnglish(str) {
            return str.replace(/[\u06F0-\u06F9]/g, (d) => d.charCodeAt(0) - 0x06F0);
        }
        const year = persianNumberToEnglish(parts.find(p => p.type === 'year')?.value || '');
        const month = persianNumberToEnglish(parts.find(p => p.type === 'month')?.value || '');
        const day = persianNumberToEnglish(parts.find(p => p.type === 'day')?.value || '');

        return {
            year: year,
            month: month,
            day: day
        }
    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentDidMount() {
        if (this.props.match.params.orderId) {
            let id = this.props.match.params.orderId;
            this.props.getItem(id)
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location) {
            this.onRouteChanged();
        }
    }

    onRouteChanged() {
        if (this.props.match.params.orderId) {
            let id = this.props.match.params.orderId;
            this.props.getItem(id)
        }
    }

    __getUserList() {
        let dataSource = [];
        let userList = [];

        if (this.props.initialValues) {
            userList = this.props.initialValues.suggested_technician;
        }

        if (userList) {

            for (let i = 0; i < userList.length; i++) {
                if (userList[i].is_active === true)
                    dataSource.push(
                        { label: userList[i].name + ' ' + userList[i].family, value: userList[i]._id, key: i }
                    );

            }

        }
        return dataSource;
    }

    // __showDay(){
    //     let day = [{label: 'روز', value: 0, key: 0}];
    //     for (let i = parseInt(this.getDate().day); i < 32; i++) {

    //         day.push(
    //             {label: i, value: i, key: i}
    //         );

    //     }
    //     return day;
    // }

    // __showMonth(){
    //     let month = [];

    //     month.push(
    //         {label: 'فروردین', value: 1, key: 1},
    //         {label: 'اردیبهشت', value: 2, key: 2},
    //         {label: 'خرداد', value: 3, key: 3},
    //         {label: 'تیر', value: 4, key: 4},
    //         {label: 'مرداد', value: 5, key: 5},
    //         {label: 'شهریور', value: 6, key: 6},
    //         {label: 'مهر', value: 7, key: 7},
    //         {label: 'آبان', value: 8, key: 8},
    //         {label: 'آذر', value: 9, key: 9},
    //         {label: 'دی', value: 10, key: 10},
    //         {label: 'بهمن', value: 11, key: 11},
    //         {label: 'اسفند', value: 12, key: 12},
    //     );

    //     const filtered = month.filter(m => m.value >= parseInt(this.getDate().month));
    //     return [{ label: 'ماه', value: 0, key: 0 }, ...filtered];
    // }

    __showDay() {
        let day = [{ label: 'روز', value: 0, key: 0 }];
        for (let i = 1; i < 32; i++) {

            day.push(
                { label: i, value: i, key: i }
            );

        }
        return day;
    }

    __showMonth() {
        let month = [];

        month.push(
            { label: 'ماه', value: 0, key: 0 },
            { label: 'فروردین', value: 1, key: 1 },
            { label: 'اردیبهشت', value: 2, key: 2 },
            { label: 'خرداد', value: 3, key: 3 },
            { label: 'تیر', value: 4, key: 4 },
            { label: 'مرداد', value: 5, key: 5 },
            { label: 'شهریور', value: 6, key: 6 },
            { label: 'مهر', value: 7, key: 7 },
            { label: 'آبان', value: 8, key: 8 },
            { label: 'آذر', value: 9, key: 9 },
            { label: 'دی', value: 10, key: 10 },
            { label: 'بهمن', value: 11, key: 11 },
            { label: 'اسفند', value: 12, key: 12 },
        );

        return month;
    }

    __showYear() {
        let year = [{ label: 'سال', value: 0, key: 0 }];
        for (let i = parseInt(this.getDate().year); i < parseInt(this.getDate().year) + 10; i++) {

            year.push(
                { label: i, value: i, key: i }
            );

        }
        return year;
    }

    __showHour() {
        let hour = [];
        for (let i = 1; i < 25; i++) {

            hour.push(
                { label: i, value: i, key: i }
            );

        }
        return hour;
    }

    __showMinute() {
        let minute = [];

        minute.push(
            { label: '00', value: '00', key: 1 },
            { label: '15', value: '15', key: 2 },
            { label: '30', value: '30', key: 3 },
            { label: '45', value: '45', key: 4 }
        );

        return minute;
    }

    __showTechnicianAssignInfo(userId) {
        this.setState({ showAssignTable: true })
        this.props.showTechnicianAssignInfo(userId)
    }

    __fixTechnicianInfoForShowInTable() {
        let list = this.props.orderAssignItem
        let fixtures = '';
        let product;
        let assignList = [];

        if (list) {

            for (let i = 0; i < list.lists.length; i++) {

                if (list.lists[i].order_type === 'ORDER_TYPE_BUY') {
                    if (list.lists[i].product)
                        product = list.lists[i].product.title
                }
                else {
                    if (list.lists[i].fixtures) {
                        for (let j = 0; j < list.lists[i].fixtures.length; j++) {
                            fixtures += list.lists[i].fixtures[j].title + ' - ';
                        }
                    }
                    fixtures = fixtures.substring(0, fixtures.length - 3);
                }

                assignList.push({
                    key: i,
                    order_type: (list.lists[i].order_type === 'ORDER_TYPE_BUY' ? 'خرید دستگاه' : 'تعمیرات'),
                    schedule_time: moment(list.lists[i].schedule_time).format('jYYYY/jM/jD'),
                    schedule_hour: list.lists[i].schedule_hour,
                    address: list.lists[i].address.text,
                });

            }

        }
        return assignList;
    }

    render() {
        var _self = this;
        const { formLayout } = this.state;

        /*---- set mode ---*/
        let orderType = '';
        let orderDescription = [];
        let description = [];
        let schedule_time;
        let hour = 1;
        let minute = 0;
        let year = 0;
        let month = 0;
        let day = 0;
        let technician_by;
        let isForce =false;
        if (this.props.initialValues) {
            description = this.props.initialValues.order.description;
            orderType = (this.props.initialValues.order.order_type === 'ORDER_TYPE_BUY' ? 'خرید دستگاه' : 'تعمیرات');
            if (this.props.initialValues.order.order_type === 'ORDER_TYPE_BUY') {
                if (this.props.initialValues.order.product)
                    orderDescription = 'درخواست خرید محصول: ' + this.props.initialValues.order.product.title;
            } else {
                orderDescription = 'درخواست تعمیرات شامل:'
                if (this.props.initialValues.order.fixtures)
                    for (let i = 0; i < this.props.initialValues.order.fixtures.length; i++) {
                        orderDescription += this.props.initialValues.order.fixtures[i].title + ' - ';
                    }
            }

            if (this.props.initialValues.order && this.props.initialValues.order.current_status === "ORDER_ASSIGNED" && this.props.initialValues.order.technician_by)
                technician_by = this.props.initialValues.order.technician_by._id

            if (this.props.initialValues.order && this.props.initialValues.order.current_status === "ORDER_ASSIGNED" && this.props.initialValues.order.schedule_time) {
                schedule_time = this.props.initialValues.order.schedule_time.split('T')
                var jalaliTime = moment.from(schedule_time[0], 'YYYY-MM-DD').locale('fa').format('YYYY-M-D');
                var split_time = jalaliTime.split('-')
                year = split_time[0]
                month = split_time[1]
                day = split_time[2]
            }

            if (this.props.initialValues.order && this.props.initialValues.order.schedule_hour && this.props.initialValues.order.schedule_hour) {
                var schedule_hour = this.props.initialValues.order.schedule_hour.split(':')
                hour = schedule_hour[0]
                minute = schedule_hour[1]
            }

            this.props.initialValues.mode = this.state.mode

            if(this.props.initialValues.order.isForce){
                isForce=true
            }

            if (this.props.initialValues.order && this.props.initialValues.order.isForce !== undefined) {
                this.props.initialValues.isForce = this.props.initialValues.order.isForce;
            }
        }

        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">تغییر تکنسین</Divider>
                </Row>
                {this.state.mode == 'edit' ?
                    <Loading list={this.props.initialValues} />
                    : null}
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <Row gutter={16}>

                            <DescriptionList label="نوع درخواست" description={orderType} />

                            <DescriptionList label="شرح خدمات" description={orderDescription} />

                            <Field
                                name="description"
                                component={TextField}
                                type="text"
                                label="توضیحات"
                                defaultValue={description}
                                placeholder="توضیحات"
                            />

                            <Field
                                name="isForce"
                                component={TextField}
                                type="checkbox"
                                label="خدمت فوری / اولویت دار"
                                // defaultValue={isForce}
                                checked={this.state.isForce}
                                onChange={(event) => {
                                    this.setState({ isForce: event.target.checked });
                                    this.props.change("isForce", event.target.checked); // sync with redux-form
                                }}
                            />

                            <Field
                                name="tekDescription"
                                component={TextField}
                                type="text"
                                label="توضیحات برای تکنیسین"
                                // defaultValue={""}
                                placeholder="توضیحات برای تکنیسین"
                            />

                            <Field
                                name="technician_by"
                                className="chooseTech"
                                component={SelectField}
                                label="انتخاب تکنسین"
                                placeholder="انتخاب تکنسین"
                                list={this.__getUserList()}
                                defaultValue={technician_by}
                                onChange={this.__showTechnicianAssignInfo.bind(this)}
                            />

                            <div>
                                <RTLCol md={20}>
                                    {this.state.showAssignTable ?
                                        <RTLTable rowClassName={(record, index) => (index + 1) % 2 == 0 ? 'even' : 'odd'} pagination={false} columns={columns} dataSource={this.__fixTechnicianInfoForShowInTable()} size="small" />
                                        : null}
                                </RTLCol>
                            </div>

                            <div>
                                <RTLCol md={24}>
                                    <RTLCol md={5} sm={24} type="flex" justify="start" align="middle" >
                                        <label>انتخاب تاریخ :</label>
                                    </RTLCol>
                                    <RTLCol md={5} sm={5} type="flex" justify="start" align="middle" >
                                        <Field
                                            name="day"
                                            component={SelectField}
                                            list={this.__showDay()}
                                            defaultValue={day}
                                        />
                                    </RTLCol>
                                    <RTLCol md={5} sm={5} type="flex" justify="start" align="middle" >
                                        <Field
                                            name="month"
                                            component={SelectField}
                                            list={this.__showMonth()}
                                            defaultValue={month}
                                        />
                                    </RTLCol>
                                    <RTLCol md={5} sm={5} type="flex" justify="start" align="middle" >
                                        <Field
                                            name="year"
                                            component={SelectField}
                                            list={this.__showYear()}
                                            defaultValue={this.getDate().year}
                                        />
                                    </RTLCol>
                                </RTLCol>
                            </div>

                            <div>
                                <RTLCol md={24}>
                                    <RTLCol md={5} sm={24} type="flex" justify="start" align="middle" >
                                        <label>انتخاب ساعت :</label>
                                    </RTLCol>
                                    <RTLCol md={5} sm={5} type="flex" justify="start" align="middle" >
                                        <Field
                                            name="hour"
                                            component={SelectField}
                                            list={this.__showHour()}
                                            defaultValue={hour}
                                        />
                                    </RTLCol>
                                    <RTLCol md={5} sm={5} type="flex" justify="start" align="middle" >
                                        <Field
                                            name="minute"
                                            component={SelectField}
                                            list={this.__showMinute()}
                                            defaultValue={minute}
                                        />
                                    </RTLCol>
                                </RTLCol>
                            </div>

                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary" shape="round" htmlType="submit" className="login-form-button">
                                {this.state.mode == 'edit' ? "ویرایش" : "ایجاد"}
                            </RTLButton>
                            <RTLButton href="#/order/list" className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>

        );
    }

}

export default AssignChangeForm = reduxForm({
    form: 'order',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(AssignChangeForm)
